(function(){
    'use strict';

    var $smpHeader = $('.smp-header'),
        $smpLower = $smpHeader.find('.smp-header__lower'),
        $smpSearch = $smpHeader.find('.smp-header__right-desktop'),
        $smpSearchBtn = $('.smp-js-smpsearch-btn'),
        $smpMobileBtn = $('.smp-js-smpmobile-btn'),
        $body = $('body');

    if($smpHeader.length){

        $smpMobileBtn.click(function(e){
            if($smpMobileBtn.hasClass('active')) {
                $smpMobileBtn.removeClass('active');
                $smpLower.removeClass('open');
                $body.removeClass('no-scroll');
            } else {
                $smpMobileBtn.addClass('active');
                $smpLower.addClass('open');
                $body.addClass('no-scroll');
                $smpSearchBtn.removeClass('active');
                $smpSearch.removeClass('open');
            }
            return false;
        });

        $smpSearchBtn.click(function(e){
            if($smpSearchBtn.hasClass('active')) {
                $smpSearchBtn.removeClass('active');
                $smpSearch.removeClass('open');
            } else {
                $smpSearchBtn.addClass('active');
                $smpSearch.addClass('open');
                $smpMobileBtn.removeClass('active');
                $smpLower.removeClass('open');
                $body.removeClass('no-scroll');
            }

            return false;
        });

    }

}());
